import { create } from 'zustand';

interface UIState {
  navVisible: boolean;
  toolbarVisible: boolean;
  openAllMenus:  () => void;
  closeAllMenus: () => void;
  setNavVisible:     (v: boolean) => void;
  setToolbarVisible: (v: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  navVisible:     true,
  toolbarVisible: true,
  openAllMenus:  () => set({ navVisible: true,  toolbarVisible: true  }),
  closeAllMenus: () => set({ navVisible: false, toolbarVisible: false }),
  setNavVisible:     (v) => set({ navVisible: v }),
  setToolbarVisible: (v) => set({ toolbarVisible: v }),
}));
